import { ReactComponent as CalendarIcon } from "../../../../assets/svg/icons/calendar.svg";
import { format } from "date-fns";
import { useFilter } from "../../../../hooks/useFilter";
import "../styles.css"

export function FilterDateDashboard() {
    const {
        setModalCalendarFilter,
        rangeDays,
        setRangeDays,
        setFocusLastDay,
        setViewRangeDays,
        selectRangeDate,
        setSelectRangeDate
    } = useFilter();


    return (
        <section className="dashBoardSupplement__container" style={{ marginTop: 30 }}>
            <div className="dashBoardInfoSupplement__container">
                <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                    <div style={{ display: "flex", gap: 10 }}>
                        <div
                            style={{ minWidth: 180, padding: "10px 20px", display: "flex", alignItems: "center", justifyContent: "center", background: selectRangeDate == 0 ? "#62b8ae" : "#fff", color: selectRangeDate == 0 ? "#fff" : "#000", borderRadius: 10, cursor: "pointer" }}
                            onClick={() => {
                                setSelectRangeDate(0)

                                const now = new Date();
                                const firstDayOfCurrentMonth = new Date(now.getFullYear(), now.getMonth(), 1);
                                const firstDayOfLastMonth = new Date(now.getFullYear(), now.getMonth() - 1, 1);

                                const range = {
                                    from: firstDayOfLastMonth,
                                    to: firstDayOfCurrentMonth
                                }
                                setRangeDays(range)
                                setViewRangeDays(range)
                            }}
                        >
                            Último mês
                        </div>

                        <div
                            style={{ minWidth: 180, padding: "10px 20px", display: "flex", alignItems: "center", justifyContent: "center", background: selectRangeDate == 1 ? "#62b8ae" : "#fff", color: selectRangeDate == 1 ? "#fff" : "#000", borderRadius: 10, cursor: "pointer" }}
                            onClick={() => {
                                setSelectRangeDate(1)

                                const now = new Date();
                                const firstDayOfCurrentMonth = new Date(now.getFullYear(), now.getMonth(), 1);
                                const firstDayOfLastMonth = new Date(now.getFullYear(), now.getMonth() - 6, 1);

                                const range = {
                                    from: firstDayOfLastMonth,
                                    to: firstDayOfCurrentMonth
                                }
                                setRangeDays(range)
                                setViewRangeDays(range)
                            }}
                        >
                            Últimos 6 meses
                        </div>

                        <div style={{ minWidth: 180, padding: "10px 20px", display: "flex", alignItems: "center", justifyContent: "center", background: selectRangeDate == 2 ? "#62b8ae" : "#fff", color: selectRangeDate == 2 ? "#fff" : "#000", borderRadius: 10, cursor: "pointer" }}
                            onClick={() => setSelectRangeDate(2)}
                        >
                            Personalizado
                        </div>
                    </div>


                    <div style={{ display: "flex", gap: 10 }}>

                        <div className="dataFilter__owner--container" onClick={() => {
                            setSelectRangeDate(2)
                            setModalCalendarFilter(true)
                            setFocusLastDay(false)
                        }}>
                            <small>De</small>
                            <div>
                                <h6>{format(rangeDays?.from ? new Date(rangeDays.from) : new Date(), 'dd/MM/yyyy')}</h6>
                                <CalendarIcon />
                            </div>
                        </div>

                        <div className="dataFilter__owner--container" onClick={() => {
                            setSelectRangeDate(2)
                            setModalCalendarFilter(true)
                            if (rangeDays?.from?.toDateString() != rangeDays?.to?.toDateString()) {
                                setFocusLastDay(true)
                            }
                            else {
                                setFocusLastDay(false)
                            }
                        }}>
                            <small>Até</small>
                            <div>
                                <h6>{format(rangeDays?.to ? new Date(rangeDays.to) : new Date(), 'dd/MM/yyyy')}</h6>
                                <CalendarIcon />
                            </div>
                        </div>
                    </div>

                    <button
                        className="dashBoardInfo__exportButton no-print"
                        onClick={() => {
                            window.print()
                        }}
                        type="button"
                    >
                        Exportar PDF
                    </button>
                    <div className="spacePrint" />
                </div>
            </div>
        </section>
    );
}